import React from 'react';
import PropTypes from 'prop-types';

import {
  COLOR_CODES_FABRIC,
  MATERIAL_OPTIONS,
  ROOM_OPTIONS,
} from 'commons/constants';
import ColorsFilter from 'components/essentials/ColorsFilter';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';

const colorsList = COLOR_CODES_FABRIC.map(obj => Object.keys(obj)[0]);

const colorsMap = {};
COLOR_CODES_FABRIC.forEach(obj => {
  colorsMap[Object.keys(obj)[0]] = true;
});

const InspirationFiltersTop = props => {
  const { filterActions, filterState } = props;

  return (
    <>
      <ShopByHeaderSection label="Material">
        <ToggleButtonGroup
          items={MATERIAL_OPTIONS.map(option => ({
            label: option.label,
            id: option.value,
            isSelected: filterState.materialFilter === option.value,
            onClick: () => {
              filterActions.onMaterialFilterChange(option.value);
            },
          }))}
          tabIndex="0"
        />
      </ShopByHeaderSection>

      <ShopByHeaderSection label="Color">
        <ColorsFilter
          colors={colorsList}
          selectedColors={filterState.colorFilters}
          onSelectColor={filterActions.onColorFilterChange}
          variant="ShopByHeaderSection"
        />
      </ShopByHeaderSection>

      <ShopByHeaderSection label="Shop by Room">
        <TogglePillGroup
          items={ROOM_OPTIONS.map(option => ({
            label: option.label,
            id: option.value,
            isSelected: filterState.roomFilter === option.value,
            onClick: () => {
              filterActions.onRoomFilterChange(option.value);
            },
          }))}
          variant="ShopByHeaderSection"
        />
      </ShopByHeaderSection>
    </>
  );
};

InspirationFiltersTop.propTypes = {
  filterActions: PropTypes.object.isRequired,
  filterState: PropTypes.object.isRequired,
};

export default InspirationFiltersTop;
